import React, {useState} from "react"
import {Form, Input, InputNumber, message, Modal, Switch, TimePicker} from "antd"
import moment from "moment"

import {withRouter} from "react-router-dom"
import {editGrouponInfo} from "../../../../../api/groupon"
import {useGroupBuyingContext} from "../../../store/useGroupBuyingContext"


const GroupBuyingEditBase = ({groupon, limitTime}) => {
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isLimitTime, setIsLimitTime] = useState(limitTime && limitTime.isLimitTime)

    const {grouponListState} = useGroupBuyingContext()

    const [form] = Form.useForm()

    const handleClick = () => {
        setIsShow(true)
    }

    const handleFinish = async () => {
        setIsLoading(true)

        const limitStartTime = form.getFieldValue('limitStartTime')
        const limitEndTime = form.getFieldValue('limitEndTime')
        const data = {
           groupon:{
               id: groupon.id,
               clubId: sessionStorage.getItem('club_id'),
               amount: (form.getFieldValue('amount') * 100).toFixed(0),
               duration: (form.getFieldValue('duration') * 60).toFixed(0),
               name: form.getFieldValue('name'),
               isEnabledOnAllTables: groupon.isEnabledOnAllTables,
           },
           limitTime: {
               isLimitTime: form.getFieldValue('isLimitTime'),
               startTime: limitStartTime ? limitStartTime.format('HH:mm:ss') : undefined,
               endTime: limitEndTime ? limitEndTime.format('HH:mm:ss') : undefined,
           }
        }
        await editGrouponInfo(data).then((res) => {
            if (res.status !== 1) {
                message.error(`更新团购信息失败：${res.detail}`)
                return
            }
            message.success('更新成功')
            setIsShow(false)
            grouponListState.reFetch()
        }).catch(err => {
            message.error(`更新失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    return (
        <div>
            <span onClick={handleClick}>编辑信息</span>
            <Modal
                open={isShow}
                onCancel={() => setIsShow(false)}
                onOk={form.submit}
                confirmLoading={isLoading}
            >
                <Form
                    style={{padding: "20px"}}
                    labelCol={{span: 6}}
                    wrapperCol={{span: 18}}
                    form={form}
                    initialValues={{
                        name: groupon.name,
                        amount: (groupon.amount / 100).toFixed(2),
                        duration: (groupon.duration / 60).toFixed(0),
                        isLimitTime: limitTime && limitTime.isLimitTime,
                        limitStartTime: limitTime && limitTime.startTime ? moment(limitTime.startTime, 'HH:mm:ss') : undefined,
                        limitEndTime: limitTime && limitTime.endTime ? moment(limitTime.endTime, 'HH:mm:ss') : undefined,
                    }}
                    onFinish={handleFinish}
                >
                    <Form.Item
                        label="团购名称"
                        name="name"
                        rules={[{required: true, message: '请输入团购名称'}]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="价格"
                        name="amount"
                        rules={[{required: true, message: '请输入价格'}]}
                    >
                        <InputNumber addonAfter={"元"} style={{width: '100%'}}/>
                    </Form.Item>
                    <Form.Item
                        label="时长"
                        name="duration"
                        rules={[{required: true, message: '请输入时长'}]}
                    >
                        <InputNumber addonAfter={"分钟"} style={{width: '100%'}}/>
                    </Form.Item>
                    <Form.Item
                        label="限时段核销"
                        name="isLimitTime"
                        valuePropName="checked"
                    >
                        <Switch onChange={(checked) => setIsLimitTime(checked)}/>
                    </Form.Item>
                    {isLimitTime && (
                        <div>
                            <Form.Item
                                label="可用开始时间"
                                name="limitStartTime"
                                rules={[{required: true, message: '请选择可用开始时间'}]}
                            >
                                <TimePicker format="HH:mm" style={{width: '100%'}}/>
                            </Form.Item>
                            <Form.Item
                                label="可用结束时间"
                                name="limitEndTime"
                                rules={[{required: true, message: '请选择可用结束时间'}]}
                            >
                                <TimePicker format="HH:mm" style={{width: '100%'}}/>
                            </Form.Item>
                        </div>
                    )}
                </Form>
            </Modal>
        </div>
    )
}

export default withRouter(GroupBuyingEditBase)



// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingEdit/component/GroupBuyingEditBase.js